import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import {
  faFileAlt,
  faCalendarCheck,
} from '@fortawesome/free-regular-svg-icons';

const Options = (props) => {
  const { activeOption, changeActiveOption } = props;

  return (
    <div className="container mx-auto px-4">
      <h3 className="heading">Help Center</h3>

      <div className="flex flex-wrap -mx-4">
        {/* Member Check-in */}
        <div
          className="w-full sm:w-1/2 lg:w-1/4 px-4"
          onClick={() => changeActiveOption(1)}
        >
          <div
            className={`help-center-option-box ${
              activeOption === 1 ? 'relative border-extended bg-white' : null
            }`}
          >
            <div className="h-16">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`help-center-option-icon ${
                  activeOption === 1 ? 'text-extended' : null
                } `}
                width="37.7"
                height="42"
                viewBox="0 0 37.7 42"
              >
                <g id="approve-invoice" transform="translate(0)">
                  <path
                    id="Path_2123"
                    data-name="Path 2123"
                    d="M60.324,0H35.788a2.549,2.549,0,0,0-2.547,2.546v5.7a11.131,11.131,0,0,0,0,21.4v9.8A2.549,2.549,0,0,0,35.788,42H55.838a.9.9,0,0,0,.634-.263L62.607,35.6a.9.9,0,0,0,.263-.634V2.546A2.549,2.549,0,0,0,60.324,0ZM35.788,1.794H60.324a.754.754,0,0,1,.753.753V5.253H35.035V2.546A.754.754,0,0,1,35.788,1.794ZM26.964,18.947A9.335,9.335,0,1,1,36.3,28.282,9.346,9.346,0,0,1,26.964,18.947Zm8.071,20.506V30a11.112,11.112,0,0,0,9.652-3.75h5.5a.9.9,0,1,0,0-1.794H45.964a11.049,11.049,0,0,0,1.422-4.548h2.8a.9.9,0,1,0,0-1.794H47.4a11.048,11.048,0,0,0-1.357-4.548h4.142a.9.9,0,0,0,0-1.794H44.8A11.112,11.112,0,0,0,35.035,7.89V7.047H61.076V34.071H57.488a2.549,2.549,0,0,0-2.546,2.546v3.589H35.788A.753.753,0,0,1,35.035,39.453Zm21.7-.516v-2.32a.753.753,0,0,1,.753-.753h2.32Z"
                    transform="translate(-25.17 0)"
                  />
                  <path
                    id="Path_2124"
                    data-name="Path 2124"
                    d="M349.643,139.663h2.979a.9.9,0,1,0,0-1.794h-2.979a.9.9,0,1,0,0,1.794Z"
                    transform="translate(-321.107 -126.092)"
                  />
                  <path
                    id="Path_2125"
                    data-name="Path 2125"
                    d="M349.643,213.9h2.979a.9.9,0,1,0,0-1.794h-2.979a.9.9,0,1,0,0,1.794Z"
                    transform="translate(-321.107 -193.992)"
                  />
                  <path
                    id="Path_2126"
                    data-name="Path 2126"
                    d="M349.643,288.146h2.979a.9.9,0,1,0,0-1.794h-2.979a.9.9,0,1,0,0,1.794Z"
                    transform="translate(-321.107 -261.892)"
                  />
                  <path
                    id="Path_2127"
                    data-name="Path 2127"
                    d="M294.678,362.387a.9.9,0,1,0,0-1.794h-8.39a.9.9,0,1,0,0,1.794Z"
                    transform="translate(-263.163 -329.792)"
                  />
                  <path
                    id="Path_2128"
                    data-name="Path 2128"
                    d="M82.981,152.237l-1.094-1.094a1.56,1.56,0,0,0-2.206,0l-5.739,5.739L72.355,155.3a1.56,1.56,0,0,0-2.206,0l-1.094,1.094a1.562,1.562,0,0,0,0,2.206l3.784,3.784a1.55,1.55,0,0,0,1.1.457h0a1.55,1.55,0,0,0,1.1-.457l7.937-7.937A1.562,1.562,0,0,0,82.981,152.237Zm-9.04,8.709-3.453-3.453.764-.764,2.055,2.055a.9.9,0,0,0,1.268,0l6.208-6.208.764.764Z"
                    transform="translate(-64.889 -137.815)"
                  />
                </g>
              </svg>
            </div>
            <p
              className={`help-center-option-text ${
                activeOption === 1 ? 'text-extended' : null
              }`}
            >
              Member Check-in
            </p>
            {activeOption === 1 ? (
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-4xl text-extended absolute top-0 left-0 pl-3 pt-3"
              />
            ) : null}
          </div>
        </div>
        {/* Request Appointment */}
        <div
          className="w-full sm:w-1/2 lg:w-1/4 px-4"
          onClick={() => changeActiveOption(2)}
        >
          <div
            className={`help-center-option-box ${
              activeOption === 2 ? 'relative border-extended bg-white' : null
            }`}
          >
            <div className="h-16">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="42"
                height="42"
                viewBox="0 0 33.994 33.994"
                className={`help-center-option-icon   ${
                  activeOption === 2 ? 'text-extended' : null
                } `}
              >
                <g id="timetable" transform="translate(0 0)">
                  <path
                    id="Path_2114"
                    data-name="Path 2114"
                    d="M32,19.4V3.054a1,1,0,0,0-1-1H25.961V1a1,1,0,0,0-1.992,0V2.058H19.985V1a1,1,0,0,0-1.992,0V2.058H14.009V1a1,1,0,0,0-1.992,0V2.058H8.034V1A1,1,0,0,0,6.042,1V2.058H1a1,1,0,0,0-1,1V29.015a1,1,0,0,0,1,1H17.582A8.96,8.96,0,1,0,32,19.4ZM6.042,4.05v1a1,1,0,0,0,1.992,0v-1h3.984v1a1,1,0,0,0,1.992,0v-1h3.984v1a1,1,0,0,0,1.992,0v-1h3.984v1a1,1,0,0,0,1.992,0v-1h4.05V8.034H1.992V4.05ZM1.992,28.019V10.026H30.011v7.556a8.953,8.953,0,0,0-12.5,2.577.99.99,0,0,0-.448-.107H15.072a1,1,0,1,0,0,1.992H16.58a8.889,8.889,0,0,0-.457,1.992H15.072a1,1,0,1,0,0,1.992h1.052a8.875,8.875,0,0,0,.457,1.992ZM25.031,32A6.972,6.972,0,1,1,32,25.031,6.979,6.979,0,0,1,25.031,32Zm0,0"
                  />
                  <path
                    id="Path_2115"
                    data-name="Path 2115"
                    d="M366.98,305.984h-2.988V303A1,1,0,1,0,362,303v3.984a1,1,0,0,0,1,1h3.984a1,1,0,1,0,0-1.992Zm0,0"
                    transform="translate(-337.965 -281.949)"
                  />
                  <path
                    id="Path_2116"
                    data-name="Path 2116"
                    d="M93.988,182H92a1,1,0,1,0,0,1.992h1.992a1,1,0,0,0,0-1.992Zm0,0"
                    transform="translate(-84.958 -169.916)"
                  />
                  <path
                    id="Path_2117"
                    data-name="Path 2117"
                    d="M93.988,242H92a1,1,0,1,0,0,1.992h1.992a1,1,0,0,0,0-1.992Zm0,0"
                    transform="translate(-84.958 -225.932)"
                  />
                  <path
                    id="Path_2118"
                    data-name="Path 2118"
                    d="M93.988,302H92a1,1,0,0,0,0,1.992h1.992a1,1,0,0,0,0-1.992Zm0,0"
                    transform="translate(-84.958 -281.949)"
                  />
                  <path
                    id="Path_2119"
                    data-name="Path 2119"
                    d="M213,183.992h1.992a1,1,0,1,0,0-1.992H213a1,1,0,0,0,0,1.992Zm0,0"
                    transform="translate(-197.924 -169.916)"
                  />
                  <path
                    id="Path_2120"
                    data-name="Path 2120"
                    d="M213,243.992h1.992a1,1,0,1,0,0-1.992H213a1,1,0,0,0,0,1.992Zm0,0"
                    transform="translate(-197.924 -225.932)"
                  />
                  <path
                    id="Path_2121"
                    data-name="Path 2121"
                    d="M93.988,362H92a1,1,0,0,0,0,1.992h1.992a1,1,0,0,0,0-1.992Zm0,0"
                    transform="translate(-84.958 -337.965)"
                  />
                  <path
                    id="Path_2122"
                    data-name="Path 2122"
                    d="M333,183.992h1.992a1,1,0,0,0,0-1.992H333a1,1,0,1,0,0,1.992Zm0,0"
                    transform="translate(-309.957 -169.916)"
                  />
                </g>
              </svg>
            </div>
            <p
              className={`help-center-option-text ${
                activeOption === 2 ? 'text-extended' : null
              }`}
            >
              Request Appointment
            </p>

            {activeOption === 2 ? (
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-4xl text-extended absolute top-0 left-0 pl-3 pt-3"
              />
            ) : null}
          </div>
        </div>
        {/* Walk-in or video visit */}
        <div
          className="w-full sm:w-1/2 lg:w-1/4 px-4"
          onClick={() => changeActiveOption(3)}
        >
          <div
            className={`help-center-option-box ${
              activeOption === 3 ? 'relative border-extended bg-white' : null
            }`}
          >
            <div className="h-16">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="47.525"
                height="47.525"
                viewBox="0 0 47.525 47.525"
                className={`help-center-option-icon  ${
                  activeOption === 3 ? 'text-extended' : null
                } `}
              >
                <g
                  id="_003-reception"
                  data-name="003-reception"
                  transform="translate(0 0)"
                >
                  <path
                    id="Path_2094"
                    data-name="Path 2094"
                    d="M45.565,53.763H2.792A.792.792,0,0,1,2,52.971V30.792A.792.792,0,0,1,2.792,30H45.565a.792.792,0,0,1,.792.792V52.971A.792.792,0,0,1,45.565,53.763ZM3.584,52.178H44.773V31.584H3.584Z"
                    transform="translate(-0.416 -6.237)"
                  />
                  <path
                    id="Path_2095"
                    data-name="Path 2095"
                    d="M53.545,25.921H48.792A.792.792,0,0,1,48,25.129V18.792A.792.792,0,0,1,48.792,18h4.753a.792.792,0,0,1,.792.792v6.337A.792.792,0,0,1,53.545,25.921Zm-3.96-1.584h3.168V19.584H49.584Z"
                    transform="translate(-9.98 -3.742)"
                  />
                  <path
                    id="Path_2096"
                    data-name="Path 2096"
                    d="M33.881,25.294H22.792A.792.792,0,0,1,22,24.5V19.75a5.105,5.105,0,0,1,1.272-3.911A3.509,3.509,0,0,1,26.015,15a.8.8,0,0,1,.5.23l1.817,1.817,1.816-1.816a.8.8,0,0,1,.5-.23,3.508,3.508,0,0,1,2.743.841,5.1,5.1,0,0,1,1.273,3.91V24.5A.792.792,0,0,1,33.881,25.294Zm-10.3-1.584h9.505V19.75A3.766,3.766,0,0,0,32.321,17a1.8,1.8,0,0,0-1.268-.427L28.9,18.725a.791.791,0,0,1-1.12,0L25.622,16.57A1.8,1.8,0,0,0,24.354,17a3.758,3.758,0,0,0-.77,2.753Z"
                    transform="translate(-4.574 -3.116)"
                  />
                  <path
                    id="Path_2097"
                    data-name="Path 2097"
                    d="M13.921,22.753H6.792A.792.792,0,0,1,6,21.96V18.792A.792.792,0,0,1,6.792,18h7.129a.792.792,0,0,1,.792.792V21.96A.792.792,0,0,1,13.921,22.753ZM7.584,21.168h5.545V19.584H7.584Z"
                    transform="translate(-1.247 -3.742)"
                  />
                  <path
                    id="Path_2098"
                    data-name="Path 2098"
                    d="M11.921,26.753H4.792A.792.792,0,0,1,4,25.96V22.792A.792.792,0,0,1,4.792,22h7.129a.792.792,0,0,1,.792.792V25.96A.792.792,0,0,1,11.921,26.753ZM5.584,25.168h5.545V23.584H5.584Z"
                    transform="translate(-0.832 -4.574)"
                  />
                  <path
                    id="Path_2099"
                    data-name="Path 2099"
                    d="M11.921,18.753H4.792A.792.792,0,0,1,4,17.96V14.792A.792.792,0,0,1,4.792,14h7.129a.792.792,0,0,1,.792.792V17.96A.792.792,0,0,1,11.921,18.753ZM5.584,17.168h5.545V15.584H5.584Z"
                    transform="translate(-0.832 -2.911)"
                  />
                  <path
                    id="Path_2100"
                    data-name="Path 2100"
                    d="M51.792,18.545A.792.792,0,0,1,51,17.753,4.758,4.758,0,0,1,55.753,13a.792.792,0,1,1,0,1.584,3.172,3.172,0,0,0-3.168,3.168A.792.792,0,0,1,51.792,18.545Z"
                    transform="translate(-10.603 -2.703)"
                  />
                  <path
                    id="Path_2101"
                    data-name="Path 2101"
                    d="M50.753,18.545a.792.792,0,0,1-.792-.792,3.172,3.172,0,0,0-3.168-3.168.792.792,0,1,1,0-1.584,4.758,4.758,0,0,1,4.753,4.753A.792.792,0,0,1,50.753,18.545Z"
                    transform="translate(-9.564 -2.703)"
                  />
                  <path
                    id="Path_2102"
                    data-name="Path 2102"
                    d="M51.792,17.921A.792.792,0,0,1,51,17.129V10.792a.792.792,0,0,1,1.584,0v6.337A.792.792,0,0,1,51.792,17.921Z"
                    transform="translate(-10.603 -2.079)"
                  />
                  <path
                    id="Path_2103"
                    data-name="Path 2103"
                    d="M27.713,51.426a8.713,8.713,0,1,1,8.713-8.713A8.723,8.723,0,0,1,27.713,51.426Zm0-15.842a7.129,7.129,0,1,0,7.129,7.129A7.136,7.136,0,0,0,27.713,35.584Z"
                    transform="translate(-3.95 -7.069)"
                  />
                  <path
                    id="Path_2104"
                    data-name="Path 2104"
                    d="M30.129,49.089H26.96a.792.792,0,0,1-.792-.792V45.921H23.792A.792.792,0,0,1,23,45.129V41.96a.792.792,0,0,1,.792-.792h2.376V38.792A.792.792,0,0,1,26.96,38h3.168a.792.792,0,0,1,.792.792v2.376H33.3a.792.792,0,0,1,.792.792v3.168a.792.792,0,0,1-.792.792H30.921V48.3A.792.792,0,0,1,30.129,49.089Zm-2.376-1.584h1.584V45.129a.792.792,0,0,1,.792-.792h2.376V42.753H30.129a.792.792,0,0,1-.792-.792V39.584H27.753V41.96a.792.792,0,0,1-.792.792H24.584v1.584H26.96a.792.792,0,0,1,.792.792Z"
                    transform="translate(-4.782 -7.901)"
                  />
                  <path
                    id="Path_2105"
                    data-name="Path 2105"
                    d="M46.733,30.753H.792A.792.792,0,0,1,0,29.96V26.792A.792.792,0,0,1,.792,26H46.733a.792.792,0,0,1,.792.792V29.96A.792.792,0,0,1,46.733,30.753ZM1.584,29.168H45.941V27.584H1.584Z"
                    transform="translate(0 -5.406)"
                  />
                  <path
                    id="Path_2106"
                    data-name="Path 2106"
                    d="M28.544,9.505H24.3a1.27,1.27,0,0,1-1.167-.732,1.454,1.454,0,0,1,.184-1.526,4.791,4.791,0,0,0,1.265-3.305A3.814,3.814,0,0,1,28.544,0,3.819,3.819,0,0,1,32.5,3.96,4.778,4.778,0,0,0,33.77,7.248a1.454,1.454,0,0,1,.184,1.526,1.268,1.268,0,0,1-1.162.732Zm0-7.921a2.26,2.26,0,0,0-2.376,2.381A6.259,6.259,0,0,1,24.8,7.921h7.481a6.239,6.239,0,0,1-1.365-3.942,2.264,2.264,0,0,0-2.376-2.394Z"
                    transform="translate(-4.782 0)"
                  />
                  <path
                    id="Path_2107"
                    data-name="Path 2107"
                    d="M31.545,23.584H26.792a.792.792,0,1,1,0-1.584h4.753a.792.792,0,1,1,0,1.584Z"
                    transform="translate(-5.406 -4.574)"
                  />
                  <path
                    id="Path_2108"
                    data-name="Path 2108"
                    d="M28.96,17.921a.79.79,0,0,1-.56-.232L26.25,15.538c-.173,0-.368,0-.44.006a.811.811,0,0,1-.718-.421.793.793,0,0,1,.055-.831c.136-.191.276-.368.416-.543a3.875,3.875,0,0,0,1.022-2.958A.792.792,0,0,1,27.376,10h3.168a.792.792,0,0,1,.792.792,3.875,3.875,0,0,0,1.022,2.958c.139.175.28.351.416.543a.793.793,0,0,1,.055.831.815.815,0,0,1-.718.421c-.072,0-.266-.006-.44-.006L29.52,17.689A.79.79,0,0,1,28.96,17.921Zm-1.772-3.684,1.772,1.772,1.772-1.772a4.994,4.994,0,0,1-.947-2.653H28.134a4.994,4.994,0,0,1-.946,2.653Z"
                    transform="translate(-5.198 -2.079)"
                  />
                  <path
                    id="Path_2109"
                    data-name="Path 2109"
                    d="M32.129,4.753H25.792A.792.792,0,0,1,25,3.96a3.96,3.96,0,0,1,7.921,0A.792.792,0,0,1,32.129,4.753ZM26.706,3.168h4.509A2.127,2.127,0,0,0,28.96,1.584,2.128,2.128,0,0,0,26.706,3.168Z"
                    transform="translate(-5.198)"
                  />
                </g>
              </svg>
            </div>
            <p
              className={`help-center-option-text ${
                activeOption === 3 ? 'text-extended' : null
              }`}
            >
              Walk-in or video visit
            </p>

            {activeOption === 3 ? (
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-4xl text-extended absolute top-0 left-0 pl-3 pt-3"
              />
            ) : null}
          </div>
        </div>
        {/* Membership */}
        <div
          className="w-full sm:w-1/2 lg:w-1/4 px-4"
          onClick={() => changeActiveOption(4)}
        >
          <div
            className={`help-center-option-box ${
              activeOption === 4 ? 'relative border-extended bg-white' : null
            }`}
          >
            <div className="h-16">
              <svg
                id="_002-id-card"
                data-name="002-id-card"
                xmlns="http://www.w3.org/2000/svg"
                width="39.011"
                height="53.76"
                viewBox="0 0 39.011 53.76"
                className={`help-center-option-icon  ${
                  activeOption === 4 ? 'text-extended' : null
                } `}
              >
                <g
                  id="Group_1101"
                  data-name="Group 1101"
                  transform="translate(12.126 48.133)"
                >
                  <g id="Group_1100" data-name="Group 1100">
                    <path
                      id="Path_2090"
                      data-name="Path 2090"
                      d="M206.5,458.407h-20.01a.775.775,0,1,0,0,1.55H206.5a.775.775,0,1,0,0-1.55Z"
                      transform="translate(-185.719 -458.407)"
                    />
                  </g>
                </g>
                <g
                  id="Group_1103"
                  data-name="Group 1103"
                  transform="translate(5.325 48.133)"
                >
                  <g id="Group_1102" data-name="Group 1102">
                    <path
                      id="Path_2091"
                      data-name="Path 2091"
                      d="M124.914,458.407h-3.194a.775.775,0,1,0,0,1.55h3.194a.775.775,0,0,0,0-1.55Z"
                      transform="translate(-120.944 -458.407)"
                    />
                  </g>
                </g>
                <g
                  id="Group_1105"
                  data-name="Group 1105"
                  transform="translate(5.325 15.295)"
                >
                  <g id="Group_1104" data-name="Group 1104">
                    <path
                      id="Path_2092"
                      data-name="Path 2092"
                      d="M147.668,145.667h-4.33a.775.775,0,1,0,0,1.55h4.33a.088.088,0,0,1,.088.088v23.969a5.334,5.334,0,0,0-3.47-3.055l-2.475-.772h0l-.223-.07-1.293-.4-.052-.016a.614.614,0,0,0-.168-.028l-.636-.18-.058-.014a.773.773,0,0,1-.425-.69v-1.19c.188-.133.372-.275.552-.429a5.763,5.763,0,0,0,1.919-3.569,1.758,1.758,0,0,0,1.41-1.721v-1.086a1.748,1.748,0,0,0-.528-1.254v-3.944a3.612,3.612,0,0,0-3.608-3.608h-6.812a3.612,3.612,0,0,0-3.608,3.608V156.8a1.748,1.748,0,0,0-.528,1.254v1.086a1.758,1.758,0,0,0,1.41,1.721,5.762,5.762,0,0,0,1.919,3.569c.18.155.364.3.552.43v1.19a.773.773,0,0,1-.425.69l-.058.014-.653.184h-.043l-.016,0h0a.7.7,0,0,0-.121.028l-.022.007-.277.086-1.239.386h0l-2.475.772a5.51,5.51,0,0,0-3.149,2.376,7.309,7.309,0,0,0-.662,1.321V147.305a.088.088,0,0,1,.088-.088H139.73a.775.775,0,0,0,0-1.55H122.582a1.64,1.64,0,0,0-1.638,1.638v27.387a1.64,1.64,0,0,0,1.505,1.632.781.781,0,0,0,.1.007H147.7a.771.771,0,0,0,.1-.007,1.64,1.64,0,0,0,1.51-1.632V147.305A1.64,1.64,0,0,0,147.668,145.667Zm-7.622,22.854.034.011-1.93,1.811a.154.154,0,0,1-.175.025l-.938-.482.194-.092C139.085,168.912,139.787,168.619,140.046,168.521Zm-1.976-.839c-.67.306-1.566.731-2.774,1.318l-.062-.03-.083-.04-.121-.059-.086-.042-.113-.055-.1-.047-.086-.041-.114-.055-.076-.037-.112-.054-.059-.028-.133-.064-.033-.016-.139-.066-.033-.016-.136-.065-.029-.014-.127-.06-.043-.02-.118-.056-.027-.013-.129-.061-.009,0L133.2,168l-.018-.008-.121-.057-.02-.009-.116-.054-.017-.008-.114-.053-.015-.007-.11-.051-.015-.007-.108-.049h0l-.024-.011a2.331,2.331,0,0,0,.664-1.635v-.381a6.428,6.428,0,0,0,2.1.37h.017a6.428,6.428,0,0,0,2.1-.37v.381A2.331,2.331,0,0,0,138.069,167.682Zm-6.18-16.887H138.7a2.059,2.059,0,0,1,2.057,2.057v3.616a4.01,4.01,0,0,0-.506.117v-2.454a1.931,1.931,0,0,0-1.929-1.929h-.674a1.978,1.978,0,0,0-1.248.445l-.161.132a2.468,2.468,0,0,1-.945.205,2.508,2.508,0,0,1-.939-.2l-.167-.137a1.977,1.977,0,0,0-1.248-.446h-.674a1.931,1.931,0,0,0-1.929,1.929v2.454a4.03,4.03,0,0,0-.506-.118v-3.616h0A2.059,2.059,0,0,1,131.889,150.8Zm-1.234,9.306a.775.775,0,0,0-.775-.759h-.371a.205.205,0,0,1-.205-.205v-1.086a.2.2,0,0,1,.017-.082,2.87,2.87,0,0,1,.67.137l.052.02.036.015c.028.013.055.026.08.04l.021.012a.615.615,0,0,1,.071.049,1.025,1.025,0,0,0,.106.075l.021.013a1.019,1.019,0,0,0,.109.056l.021.009a.992.992,0,0,0,.111.039l.01,0a1,1,0,0,0,.12.024l.026,0a.972.972,0,0,0,.11.007h.01l.033,0c.032,0,.063,0,.1-.008l.043-.007c.03-.005.059-.012.089-.021l.039-.011a1.044,1.044,0,0,0,.123-.048.993.993,0,0,0,.574-.906v-3.336a.378.378,0,0,1,.378-.378h.674a.423.423,0,0,1,.267.1l.167.137a3.627,3.627,0,0,0,3.84,0l.167-.137a.423.423,0,0,1,.267-.1h.674a.378.378,0,0,1,.378.378v3.336a.993.993,0,0,0,.574.906,1.035,1.035,0,0,0,.108.042,1.006,1.006,0,0,0,.136.036.986.986,0,0,0,.739-.152c.028-.018.055-.036.081-.058a.6.6,0,0,1,.073-.05l.016-.009a2.318,2.318,0,0,1,.84-.214.2.2,0,0,1,.018.083v1.086a.205.205,0,0,1-.205.205h-.371a.775.775,0,0,0-.775.759,4.264,4.264,0,0,1-1.44,3.152,5.435,5.435,0,0,1-.7.512c-.017.01-.034.02-.051.031a4.7,4.7,0,0,1-4.9,0c-.017-.011-.034-.022-.052-.032a5.418,5.418,0,0,1-.7-.511A4.263,4.263,0,0,1,130.655,160.1Zm-.108,8.42.083.032.026.01.087.035.012,0,.108.045.038.016.1.043.026.011.127.056.056.025.1.045.048.021.141.063.073.033.1.045.076.035.145.066.086.039.1.045.1.047.148.068.09.042.106.049.1.045.169.079.1.049.1.045.113.053.172.081.11.052.1.048.072.034-.939.482a.154.154,0,0,1-.175-.025l-1.93-1.811Zm-7.151,6.26h0c.342-2.815,1.468-4.521,3.354-5.076l.012,0,2.05-.639,2.57,2.411a1.707,1.707,0,0,0,1.944.273h0l1.97-1.012,1.97,1.012a1.708,1.708,0,0,0,1.945-.273l2.57-2.411,2.049.639.012,0c1.949.574,2.983,2.28,3.08,5.076Z"
                      transform="translate(-120.944 -145.667)"
                    />
                  </g>
                </g>
                <g
                  id="Group_1107"
                  data-name="Group 1107"
                  transform="translate(0)"
                >
                  <g id="Group_1106" data-name="Group 1106">
                    <path
                      id="Path_2093"
                      data-name="Path 2093"
                      d="M107.068,5.543H94.732V1.889A1.891,1.891,0,0,0,92.843,0H86.632a1.891,1.891,0,0,0-1.889,1.889V5.543H72.407a2.178,2.178,0,0,0-2.175,2.175V51.585a2.178,2.178,0,0,0,2.175,2.175h34.661a2.178,2.178,0,0,0,2.175-2.175V7.718A2.178,2.178,0,0,0,107.068,5.543ZM86.293,1.889a.339.339,0,0,1,.338-.338h6.212a.339.339,0,0,1,.338.338v5.36a.338.338,0,0,1-.119.257l-3.106,2.648a.337.337,0,0,1-.439,0L86.412,7.506a.338.338,0,0,1-.119-.257Zm8.454,8.639a.487.487,0,0,1,.486.486v.853a.487.487,0,0,1-.486.486H84.729a.487.487,0,0,1-.486-.486v-.853a.487.487,0,0,1,.486-.486h2.839l.945.806a1.881,1.881,0,0,0,2.451,0l.945-.806Zm12.946,41.056h0a.626.626,0,0,1-.625.625H72.407a.625.625,0,0,1-.625-.625V7.718a.625.625,0,0,1,.625-.625H84.743v.156a1.886,1.886,0,0,0,.663,1.438l.342.291h-1.02a2.039,2.039,0,0,0-2.037,2.037v.853A2.039,2.039,0,0,0,84.728,13.9H94.747a2.039,2.039,0,0,0,2.037-2.037v-.853a2.039,2.039,0,0,0-2.037-2.037h-1.02l.342-.291a1.886,1.886,0,0,0,.664-1.438V7.093h12.336a.625.625,0,0,1,.625.625V51.584Z"
                      transform="translate(-70.232)"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <p
              className={`help-center-option-text ${
                activeOption === 4 ? 'text-extended' : null
              }`}
            >
              Membership
            </p>

            {activeOption === 4 ? (
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-4xl text-extended absolute top-0 left-0 pl-3 pt-3"
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Options;
